import axios from "axios";
import environment from "environments/environment";

const { baseUrl } = environment;

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

// 💡 Interceptor runs before every request
axiosInstance.interceptors.request.use((config) => {
  const clinicId = sessionStorage.getItem("clinicId");
  if (clinicId) {
    config.headers["ClinicId"] = clinicId;
  }
  return config;
});

export default axiosInstance;
